module.exports = __webpack_public_path__ + "img/bg-sect-2.09e4a0d9.png";